export default __webpack_public_path__ + "static/media/mark.3cc8d959.svg";